<template>
  <div>
    <div class="search-header-container">
      <div v-show="!showFilters" class="toggle">
        <FiltersToggle />
      </div>
      <div class="title-description-container">
        <div class="title">
          <h1>{{ actualSearchTitle }}</h1>
        </div>
        <div class="description">
          <h2>{{ actualSearchDescription }}</h2>
        </div>
      </div>
      <div v-if="tags.length > 0" class="tags-container">
        <span class="relateds-title">{{ $t('main.searchResult.searchHeader.text') }}</span>
        <div v-for="(t, i) in tags" :key="i" class="related-link">
          <nuxt-link v-if="t.type == 'internal'" :to="internalLink(t.dimension, t.slug)">{{
            t.text
          }}</nuxt-link>
          <a v-else :href="t.url" target="_blank">{{ t.text }}</a
          ><span v-if="i < tags.length - 1">,&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="filters-container">
      <div v-if="getExperience" class="filter-tag">
        {{ userExperienceText }}
        <Icon
          icon="bootstrap-x"
          class="filter-cross cursor-pointer"
          :width="16"
          :height="16"
          @click.native="removeExperience"
        />
      </div>
      <div class="filter-tag" :class="{ 'small-padding': !showRemoveDimension }">
        {{ getActualDimensionName }}
        <Icon
          v-if="showRemoveDimension"
          icon="bootstrap-x"
          class="filter-cross cursor-pointer"
          :width="16"
          :height="16"
          @click.native="removeDimension"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import FiltersToggle from '@/components/SearchResults/FiltersToggle';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    Icon,
    FiltersToggle
  },
  computed: {
    ...mapState('dimensions', ['dimensionOptions']),
    ...mapGetters('dimensions', [
      'getActualDimensionName',
      'getDimensionAll',
      'getDimensionByName'
    ]),
    ...mapGetters('experience', ['getExperience']),
    ...mapGetters('searchBar', ['getActualSearch']),
    actualSearchTitle() {
      return this.$store.getters['search/getSearchTitle'];
    },
    actualSearchDescription() {
      return this.$store.getters['search/getSearchDescription'];
    },
    showFilters() {
      return this.$store.getters['search/getFiltersVisibility'];
    },
    tags() {
      return this.$store.getters['search/getSearchRelatedTags'];
    },
    userExperienceText() {
      return this.getExperience.charAt(0).toUpperCase() + this.getExperience.slice(1);
    },
    showRemoveDimension() {
      return this.getActualDimensionName !== this.getDimensionAll;
    }
  },
  methods: {
    removeExperience() {
      this.makeSearch();
    },
    removeDimension() {
      if (this.getActualDimensionName !== this.getDimensionAll) {
        this.makeSearch(this.getExperience);
      }
    },
    makeSearch(experience) {
      if (!experience) {
        this.$store.dispatch('experience/SET_USER_EXPERIENCE', experience);
      }

      this.$store.dispatch('dimensions/ACTUAL_DIMENSION', this.getDimensionAll);

      this.$router.push({
        path: this.$urlBuilder('search', {
          path: this.getDimensionByName(this.getDimensionAll, experience).path,
          keyword: this.getActualSearch
        })
      });
    },
    internalLink(dimension, slug) {
      return this.$urlBuilder('search', {
        path: dimension,
        keyword: slug
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-header-container .toggle {
  @include lg {
    display: block;
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 300;
  }
}

.search-header-container .title-description-container {
  flex: 1;
  margin-left: 10px;
  padding-right: 20px;
  @include sm {
    margin-left: 0;
    padding-right: 0;
  }
}
.search-header-container .title-description-container .title h1 {
  font-size: 18px;
  color: #2d2d2d;
  text-transform: lowercase;
}
.search-header-container .title-description-container .description h2 {
  font-size: 14px;
  color: $strongGray;
  text-transform: lowercase;
  font-weight: 400;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.relateds-title {
  color: #888888;
  text-transform: lowercase;
  font-weight: 400;
}
.tags-container {
  .related-link {
    a,
    span {
      color: var(--exp-color);
    }
    &:hover {
      filter: brightness(0.9);
    }
  }
  display: flex;
  align-items: center;
  justify-content: center;
  @include lg {
    display: block;
  }
  @include sm {
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
  }
}
.tags-container .relateds-title {
  margin-right: 3px;
}
.filters-container {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .filter-tag {
    padding: 5px 5px 5px 10px;
    border: 1px solid #c5c5c5;
    border-radius: 4px;
    margin: 0 5px 0 0;
    font-size: 13px;
    color: #535353;
    &.small-padding {
      padding-right: 10px;
    }
  }
  .filter-cross {
    font-size: 16px;
    position: relative;
    top: 2px;
    margin-left: 2px;
  }
}

@media all and (min-width: 576px) {
  .search-header-container {
    display: flex;
    margin-top: 15px;
    margin-bottom: 15px;
    position: initial;
  }
}
</style>
